import script from "./RegistrationConfirmForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegistrationConfirmForm.vue?vue&type=script&setup=true&lang=ts"

import "./RegistrationConfirmForm.vue?vue&type=style&index=0&id=14516568&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14516568"]])

export default __exports__